import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  Svg,
  Line,
  Link,
} from '@react-pdf/renderer';
import intelImage from '../assets/images/IntelLogo.png';
import ibmImage from '../assets/images/ibmLogo.png';
import topHeaderImage from '../assets/images/TopHeader.png';
import headerLeftImage from '../assets/images/HeaderLeft.png';
import computerImage from '../assets/images/Computer.png';
import envelopeImage from '../assets/images/Envelope.png';
import copyrightImage from '../assets/images/Copyright.png';
import { useIntl } from 'react-intl';
import messages from '../locales/messages';
import { InputType, pdfBase64HeaderImage } from '../utils/data';
import { useEffect, useState } from 'react';
import {
  numberWithCommas,
  numberWithCommasAndDollar,
} from '../utils/Formatters';

export interface IBMESGProps {
  totalCurrentCost: any;
  totalIBMCost: any;
  totalCost: any;
  inputType: InputType;
  isAdvanceSelected: boolean;
  chartDataUrl: string;
}
export const PDFGenerate = ({
  totalCurrentCost,
  totalIBMCost,
  totalCost,
  inputType,
  isAdvanceSelected,
  chartDataUrl,
}: IBMESGProps) => {
  const intl = useIntl();
  const [imageData, setImageData] = useState<string | ''>('');
  const [width, setWidth] = useState<number>(100);
  const [height, setHeight] = useState<number>(150);
  const [currentDate, setCurrentDate] = useState<string>('');
  const [year, setCurrentYear] = useState<number>(2024);

  const styles = StyleSheet.create({
    page: {
      backgroundColor: '#f4f4f4',
      paddingTop: 0,
      paddingBottom: 0,
      //fontFamily: 'IBMPlexSans',
    },
    headerSection: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'justify',
    },
    headerImage: {
      width: 'auto',
      height: '110',
    },
    topHeaderImageSection: {
      width: '200',
      height: '50',
    },
    topHeaderImage: {
      position: 'absolute',
      width: '140',
      top: 7,
      left: 110,
    },
    topHeaderImage2: {
      position: 'absolute',
      width: '80',
      top: 15,
      left: 20,
    },
    topHeaderImage3: {
      position: 'absolute',
      width: '90',
      top: 13,
      left: 250,
    },
    headerText: {
      color: '#0E2841',
      width: 'auto',
      paddingTop: 8,
      textAlign: 'left',
      fontSize: 22,
      fontWeight: 'bold',
    },
    sectionHeaderText: {
      color: '#4472C4',
      width: 'auto',
      paddingTop: 20,
      paddingBottom: 5,
      textAlign: 'left',
      fontSize: 18,
      fontWeight: 'bold',
    },
    sectionAbstractHeaderText: {
      color: '#4472C4',
      textAlign: 'left',
      fontSize: 14,
      lineHeight: 0.3,
      fontWeight: 'bold',
    },
    sectionText: {
      lineHeight: 1.1,
      textAlign: 'left',
      fontSize: 11.5,
      fontWeight: 'normal',
    },
    sectionTextBold: {
      lineHeight: 1.1,
      textAlign: 'left',
      fontSize: 11.5,
      fontWeight: 'bold',
    },
    line: {
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'justify',
      flexWrap: 'wrap',
    },
    section: {
      textAlign: 'justify',
      width: 'auto',
      marginLeft: 35,
      marginRight: 35,
      marginTop: 60,
    },
    chartSection: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'auto',
      marginTop: 5,
    },
    viewFlex: {
      display: 'flex',
      flexDirection: 'row',
    },
    viewFlexCol: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: 0,
    },
    viewFlex1: {
      display: 'flex',
      lineHeight: 1,
      flexDirection: 'row',
    },
    valueInputs: {
      fontSize: 10,
      width: 100,
      textAlign: 'center',
      paddingTop: 2,
    },
    valueInputsBold: {
      fontSize: 10,
      width: 100,
      textAlign: 'center',
      paddingTop: 2,
      fontWeight: 'bold',
    },
    valueInputs1: {
      fontSize: 10,
      width: 120,
      textAlign: 'center',
      paddingTop: 2,
    },
    valueInputsBold1: {
      fontSize: 10,
      width: 120,
      textAlign: 'center',
      paddingTop: 2,
      fontWeight: 'bold',
    },
    bold: { fontWeight: 'bold' },
    chartTable1: { marginTop: 25, textAlign: 'center' },
    chartTable2: { marginTop: 15, marginLeft: 115 },
    otherSource: {
      fontSize: 9,
      textAlign: 'left',
      color: '#B8B8B8',
      flexWrap: 'wrap',
    },
    abstractTextCount: {
      fontSize: 7,
      verticalAlign: 'super',
      marginTop: -4,
    },
    footerText1: {
      fontSize: 8,
      textAlign: 'center',
      color: '#B8B8B8',
    },
    footerText2: {
      fontSize: 9,
      textAlign: 'center',
      color: 'grey',
    },
    footerImage: {
      width: 7,
      height: 7,
      textAlign: 'right',
    },
    footerSection: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'justify',
      position: 'absolute',
      justifyContent: 'space-between',
      bottom: 20,
      left: 0,
      right: 0,
    },
    footerSubSection: {
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 5,
    },
    headerSection2: {
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'justify',
      position: 'absolute',
      top: 20,
      left: 35,
      right: 35,
    },
    headerText1: {
      width: '25%',
      textAlign: 'left',
    },
    headerText2: {
      width: '75%',
      top: 8,
      fontSize: 9,
      textAlign: 'right',
      color: '#B8B8B8',
    },
    sectionHidden: { display: 'none' },
    footer2: {
      backgroundColor: '#e2e2e2',
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      justifyContent: 'center',
      bottom: 0,
      left: 0,
      right: 0,
      paddingLeft: 35,
      paddingRight: 35,
      paddingBottom: 30,
    },
    footerSection1: {
      top: 8,
      color: '#5C5C5C',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
    },
    footerSection2: {
      top: 16,
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'center',
    },
    footer2Section1: {
      width: '75%',
      fontSize: 8,
      textAlign: 'left',
      color: '#5C5C5C',
    },
    footer2Section2: {
      width: '25%',
      fontSize: 8,
      textAlign: 'right',
      color: '#5C5C5C',
      alignContent: 'center',
      marginLeft: 5,
    },
    footer2Text: {
      fontSize: 8,
      marginTop: 5,
      marginBottom: 5,
      textAlign: 'left',
      color: '#5C5C5C',
    },
    footerCopyrightText: {
      fontSize: 8,
      textAlign: 'left',
      color: '#5C5C5C',
    },
    link: {
      color: 'blue',
      textDecoration: 'underline',
      marginLeft: 5,
    },
    chartImage: {
      width: 100,
      height: 200,
    },
    footerInfoSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      textAlign: 'left',
      padding: 2,
    },
    infoIcons: {
      width: '10%',
      textAlign: 'left',
    },
  });

  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toLocaleDateString();
    setCurrentDate(formattedDate);
    setCurrentYear(date.getFullYear());
  }, []);

  useEffect(() => {
    if (chartDataUrl) {
      setWidth(390);
      setHeight(210);
      setImageData(chartDataUrl);
    }
  }, [chartDataUrl]);
  Font.registerHyphenationCallback((word) => [word]);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={[styles.headerSection]}>
          <Image style={styles.headerImage} src={pdfBase64HeaderImage} />
          <Image style={styles.topHeaderImage} src={topHeaderImage} />
          <Image style={styles.topHeaderImage2} src={ibmImage} />
          <Image style={styles.topHeaderImage3} src={intelImage} />
          <View style={[styles.section, { marginTop: 20 }]}>
            <Text style={styles.sectionText}>{currentDate}</Text>
            <Text style={styles.headerText}>
              {intl.formatMessage(messages.report_header)}
            </Text>

            <Text style={styles.sectionHeaderText}>
              {intl.formatMessage(messages.abstract)}
            </Text>
            <Text style={[styles.sectionText]}>
              {intl.formatMessage(messages.abstract_text1)}
            </Text>
            <Text
              style={[
                styles.sectionText,
                { marginTop: 10, marginLeft: 30, marginRight: 16 },
              ]}
            >
              {intl.formatMessage(messages.abstract_text21)}
            </Text>
            <Text
              style={[
                styles.sectionText,
                { marginTop: 10, marginLeft: 30, marginRight: 16 },
              ]}
            >
              {intl.formatMessage(messages.abstract_text221)}
              <Text style={[styles.abstractTextCount]}>{'1'}</Text>
              {intl.formatMessage(messages.abstract_text222)}
              <Text style={[styles.abstractTextCount]}>{'2'}</Text>
              {intl.formatMessage(messages.abstract_text223)}
            </Text>
            <Text style={[styles.sectionText, { marginTop: 10 }]}>
              {intl.formatMessage(messages.abstract_text3)}
            </Text>

            <Text style={styles.sectionHeaderText}>
              {intl.formatMessage(messages.the_solution)}
            </Text>
            <Text style={styles.sectionText}>
              {intl.formatMessage(messages.the_solution_text)}
            </Text>
          </View>
        </View>
        <View style={styles.footerSection} fixed>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Svg height="5" width="130">
              <Line
                x1="0"
                y1="5"
                x2="400"
                y2="5"
                strokeWidth={1.5}
                stroke="rgb(0,0,0)"
              />
            </Svg>
            <Text style={[styles.otherSource, { marginTop: 6 }]}>
              <Text style={[styles.abstractTextCount]}>{'1 '}</Text>
              {intl.formatMessage(messages.other_source1)}{' '}
              <Link
                style={[styles.link]}
                src={`https://research.esg-global.com/reportaction/515201849/Toc?`}
              >
                {intl.formatMessage(messages.other_source1text)}
              </Link>
              {', July 2024'}
            </Text>
            <Text style={[styles.otherSource, { marginTop: 4 }]}>
              <Text style={[styles.abstractTextCount]}>{'2 '}</Text>
              {intl.formatMessage(messages.other_source2)}{' '}
              <Link
                style={[styles.link, { flexWrap: 'wrap' }]}
                src={`https://research.esg-global.com/reportaction/515201729/Marketing?SearchTerms=Source%3A%20Navigating%20the%20Cloud%20and%20AI%20Revolution%3A%20The%20State%20of%20Enterprise%20Storage%20and%20HCI%2C%20January%202024}`}
              >
                {intl.formatMessage(messages.other_source2text)}
              </Link>
              {', February 2024'}
            </Text>
          </View>
          <Text style={styles.footerText1}>
            {intl.formatMessage(messages.footer_text1)}
          </Text>
          <View style={[styles.footerSubSection]}>
            <Image style={styles.footerImage} src={copyrightImage} />
            <Text style={[styles.footerText2]}>
              {intl.formatMessage(messages.footer_text2, { year })}
            </Text>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={styles.headerSection2} fixed>
          <Image style={styles.headerText1} src={headerLeftImage} />
          <Text style={[styles.headerText2]}>
            {intl.formatMessage(messages.header_text1)}
          </Text>
        </View>

        <View style={[styles.section]}>
          <Text style={styles.sectionHeaderText}>
            {intl.formatMessage(messages.your_result)}
          </Text>
          <Text style={styles.sectionText}>
            {intl.formatMessage(messages.your_result_text)}
          </Text>

          {!isAdvanceSelected && (
            <View>
              <View style={[styles.line, { marginTop: 15 }]}>
                <Text style={styles.sectionText}>
                  {intl.formatMessage(messages.if_advance_is_selected11)}
                </Text>
                <Text style={styles.sectionTextBold}>
                  {numberWithCommas(inputType.totalVMs)}
                </Text>
                <Text style={styles.sectionText}>
                  {intl.formatMessage(messages.if_advance_is_selected12)}
                </Text>
                <Text style={styles.sectionText}>
                  {intl.formatMessage(messages.if_advance_is_selected13)}
                </Text>
              </View>
              <View style={[styles.viewFlex, { marginTop: 5, marginLeft: 55 }]}>
                <View>
                  <View style={styles.viewFlex1}>
                    <Text style={styles.valueInputs}></Text>
                    <Text style={styles.valueInputs}></Text>
                    <Text style={styles.valueInputsBold}>vCPU</Text>
                    <Text style={styles.valueInputsBold}>GiB Memeory</Text>
                  </View>
                  <Svg height="5" width="495">
                    <Line
                      x1="0"
                      y1="5"
                      x2="400"
                      y2="5"
                      strokeWidth={1.5}
                      stroke="rgb(0,0,0)"
                    />
                  </Svg>
                  <View style={styles.viewFlex1}>
                    <Text style={styles.valueInputs}>
                      {intl.formatMessage(messages.x_small)}:
                    </Text>
                    <Text style={styles.valueInputsBold}>
                      {numberWithCommas(inputType.xSmallSize)}
                    </Text>
                    <Text style={styles.valueInputs}>1</Text>
                    <Text style={styles.valueInputs}>1</Text>
                  </View>
                  <Svg height="5" width="495">
                    <Line
                      x1="0"
                      y1="5"
                      x2="400"
                      y2="5"
                      strokeWidth={1.5}
                      stroke="rgb(0,0,0)"
                    />
                  </Svg>
                  <View style={styles.viewFlex1}>
                    <Text style={styles.valueInputs}>
                      {intl.formatMessage(messages.small)}:
                    </Text>
                    <Text style={styles.valueInputsBold}>
                      {numberWithCommas(inputType.smallSize)}
                    </Text>
                    <Text style={styles.valueInputs}>1</Text>
                    <Text style={styles.valueInputs}>4</Text>
                  </View>
                  <Svg height="5" width="495">
                    <Line
                      x1="0"
                      y1="5"
                      x2="400"
                      y2="5"
                      strokeWidth={1.5}
                      stroke="rgb(0,0,0)"
                    />
                  </Svg>
                  <View style={styles.viewFlex1}>
                    <Text style={styles.valueInputs}>
                      {intl.formatMessage(messages.medium)}:
                    </Text>
                    <Text style={styles.valueInputsBold}>
                      {numberWithCommas(inputType.mediumSize)}
                    </Text>
                    <Text style={styles.valueInputs}>2</Text>
                    <Text style={styles.valueInputs}>4</Text>
                  </View>
                  <Svg height="5" width="495">
                    <Line
                      x1="0"
                      y1="5"
                      x2="400"
                      y2="5"
                      strokeWidth={1.5}
                      stroke="rgb(0,0,0)"
                    />
                  </Svg>
                  <View style={styles.viewFlex1}>
                    <Text style={styles.valueInputs}>
                      {intl.formatMessage(messages.large)}:
                    </Text>
                    <Text style={styles.valueInputsBold}>
                      {numberWithCommas(inputType.largeSize)}
                    </Text>
                    <Text style={styles.valueInputs}>4</Text>
                    <Text style={styles.valueInputs}>24</Text>
                  </View>
                  <Svg height="5" width="495">
                    <Line
                      x1="0"
                      y1="5"
                      x2="400"
                      y2="5"
                      strokeWidth={1.5}
                      stroke="rgb(0,0,0)"
                    />
                  </Svg>
                  <View style={styles.viewFlex1}>
                    <Text style={styles.valueInputs}>
                      {intl.formatMessage(messages.x_large)}:
                    </Text>
                    <Text style={styles.valueInputsBold}>
                      {numberWithCommas(inputType.xLargeSize)}
                    </Text>
                    <Text style={styles.valueInputs}>8</Text>
                    <Text style={styles.valueInputs}>48</Text>
                  </View>
                  <Svg height="5" width="495">
                    <Line
                      x1="0"
                      y1="5"
                      x2="400"
                      y2="5"
                      strokeWidth={1.5}
                      stroke="rgb(0,0,0)"
                    />
                  </Svg>
                </View>
              </View>
            </View>
          )}
          {isAdvanceSelected ? (
            <View style={[styles.line, { marginTop: 20 }]}>
              <Text style={[styles.sectionText]}>
                {intl.formatMessage(messages.if_advance_is_not_selected11)}
              </Text>
              <Text style={styles.sectionTextBold}>
                {numberWithCommas(inputType.nbr_VMs)}
              </Text>
              <Text style={styles.sectionText}>
                {intl.formatMessage(messages.if_advance_is_not_selected12)}
              </Text>
              <Text style={[styles.sectionText]}>
                {intl.formatMessage(messages.if_advance_is_not_selected13)}
              </Text>
              <Text style={styles.sectionTextBold}>
                {numberWithCommasAndDollar(totalCost.totalSavings)}
              </Text>
              <Text style={styles.sectionText}>{'.'}</Text>
            </View>
          ) : (
            <View style={[styles.line, { marginTop: 8 }]}>
              <Text style={[styles.sectionText]}>
                {intl.formatMessage(messages.if_advance_is_selected211)}
              </Text>
              <Text style={styles.sectionTextBold}>
                {numberWithCommas(inputType.replatform)}
              </Text>
              <Text style={styles.sectionText}>
                {intl.formatMessage(messages.if_advance_is_selected212)}
              </Text>
              <Text style={styles.sectionText}>
                {intl.formatMessage(messages.if_advance_is_selected213)}
              </Text>
            </View>
          )}
          {!isAdvanceSelected && (
            <View style={[styles.line, { marginTop: 10 }]}>
              <Text style={[styles.sectionText]}>
                {intl.formatMessage(messages.if_advance_is_selected221)}
              </Text>
              <Text style={styles.sectionText}>
                {intl.formatMessage(messages.if_advance_is_selected222)}
              </Text>
              <Text style={styles.sectionTextBold}>
                {numberWithCommasAndDollar(totalCost.totalSavings)}
              </Text>
              <Text style={styles.sectionText}>{'.'}</Text>
            </View>
          )}
          <Text style={[styles.sectionText, { marginTop: 10 }]}>
            {intl.formatMessage(messages.if_advance_is_not_selected2)}
          </Text>
          <View style={[styles.chartSection]}>
            <View style={styles.chartTable2}>
              <View style={[]}>
                <View style={[styles.viewFlex1]}>
                  <Text style={styles.valueInputs1}></Text>
                  <Text style={styles.valueInputsBold1}>
                    {intl.formatMessage(messages.current)}
                  </Text>
                  <Text style={styles.valueInputsBold1}>
                    {intl.formatMessage(messages.with_ibm_fusion)}
                  </Text>
                </View>
                <Svg height="5" width="395">
                  <Line
                    x1="0"
                    y1="5"
                    x2="380"
                    y2="5"
                    strokeWidth={1.5}
                    stroke="rgb(0,0,0)"
                  />
                </Svg>
                <View style={styles.viewFlex1}>
                  <Text style={styles.valueInputs1}>
                    {intl.formatMessage(
                      messages.infrastructure_and_administration,
                    )}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalCurrentCost.totalAnnualSalary)}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalIBMCost.totalAnnualAdminCostIBM)}
                  </Text>
                </View>
                <Svg height="5" width="495">
                  <Line
                    x1="0"
                    y1="5"
                    x2="380"
                    y2="5"
                    strokeWidth={1.5}
                    stroke="rgb(0,0,0)"
                  />
                </Svg>
                <View style={styles.viewFlex1}>
                  <Text style={styles.valueInputs1}>
                    {intl.formatMessage(messages.support_Maintenance)}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(
                      totalCurrentCost.totalMaintenanceSupportCurrent,
                    )}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalIBMCost.totalMaintenanceSupportIBM)}
                  </Text>
                </View>
                <Svg height="5" width="495">
                  <Line
                    x1="0"
                    y1="5"
                    x2="380"
                    y2="5"
                    strokeWidth={1.5}
                    stroke="rgb(0,0,0)"
                  />
                </Svg>
                <View style={styles.viewFlex1}>
                  <Text style={styles.valueInputs1}>
                    {intl.formatMessage(messages.software)}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalCurrentCost.totalSoftwareCurrent)}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalIBMCost.totalIBMSoftwareCosts)}
                  </Text>
                </View>
                <Svg height="5" width="495">
                  <Line
                    x1="0"
                    y1="5"
                    x2="380"
                    y2="5"
                    strokeWidth={1.5}
                    stroke="rgb(0,0,0)"
                  />
                </Svg>
                <View style={styles.viewFlex1}>
                  <Text style={styles.valueInputs1}>
                    {intl.formatMessage(messages.hardware)}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalCurrentCost.totalHardwareCurrent)}
                  </Text>
                  <Text style={styles.valueInputs1}>
                    {numberWithCommas(totalIBMCost.totalHardwareCosts)}
                  </Text>
                </View>
                <Svg height="5" width="495">
                  <Line
                    x1="0"
                    y1="5"
                    x2="380"
                    y2="5"
                    strokeWidth={1.5}
                    stroke="rgb(0,0,0)"
                  />
                </Svg>
                <View style={styles.viewFlex1}>
                  <Text style={styles.valueInputsBold1}>
                    {intl.formatMessage(messages.total)}
                  </Text>
                  <Text style={styles.valueInputsBold1}>
                    {numberWithCommas(totalCost.totalCurrent)}
                  </Text>
                  <Text style={styles.valueInputsBold1}>
                    {numberWithCommas(totalCost.totalIBM)}
                  </Text>
                </View>
                <Svg height="5" width="495">
                  <Line
                    x1="0"
                    y1="5"
                    x2="380"
                    y2="5"
                    strokeWidth={1.5}
                    stroke="rgb(0,0,0)"
                  />
                </Svg>
              </View>
            </View>
            <View style={[styles.chartTable1]}>
              {chartDataUrl && (
                <Image style={[{ width, height }]} src={imageData} />
              )}
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={styles.headerSection2} fixed>
          <Image style={styles.headerText1} src={headerLeftImage} />
          <Text style={[styles.headerText2]}>
            {intl.formatMessage(messages.header_text1)}
          </Text>
        </View>
        <View style={[styles.section]}>
          <View style={[styles.viewFlex]}>
            <View>
              <Text style={[styles.sectionHeaderText, { paddingTop: 15 }]}>
                {intl.formatMessage(messages.conclusion)}
              </Text>
              <Text style={styles.sectionText}>
                {intl.formatMessage(messages.conclusion_text1)}{' '}
                <Link
                  style={styles.link}
                  src={`https://www.ibm.com/downloads/cas/4YNZQVK2`}
                >
                  {intl.formatMessage(messages.page_title2)}
                </Link>{' '}
                {intl.formatMessage(messages.conclusion_text2)}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.footer2} fixed>
          <View style={styles.footerSection1}>
            <View style={[styles.line, { marginBottom: 5 }]}>
              <View style={[styles.footerSubSection]}>
                <Image style={styles.footerImage} src={copyrightImage} />
                <Text style={styles.footerCopyrightText}>
                  {intl.formatMessage(messages.footer2_text11)}
                </Text>
              </View>
              <Text style={styles.footerCopyrightText}>
                {intl.formatMessage(messages.footer2_text12)}
              </Text>
            </View>
            <Text style={[styles.footer2Text]}>
              {intl.formatMessage(messages.footer2_text2)}
            </Text>
            <Text style={[styles.footer2Text]}>
              {intl.formatMessage(messages.footer2_text3)}{' '}
              <Link
                style={styles.link}
                src={`mailto:${intl.formatMessage(messages.footer2_contact1)}`}
              >
                {intl.formatMessage(messages.footer2_contact1)}
              </Link>
            </Text>
            <Svg height="5" width="550">
              <Line
                x1="0"
                y1="5"
                x2="525"
                y2="5"
                strokeWidth={1.5}
                stroke="rgb(92, 92, 92)"
              />
            </Svg>
          </View>
          <View style={styles.footerSection2}>
            <View style={[styles.footer2Section1]}>
              <Text style={[styles.bold, { fontSize: 10 }]}>
                {intl.formatMessage(messages.footer2_text4)}
              </Text>
              <Text>{intl.formatMessage(messages.footer2_text5)}</Text>
            </View>
            <View style={[styles.footer2Section2]}>
              <View style={[styles.footerInfoSection]}>
                <Image style={styles.infoIcons} src={envelopeImage} />
                <Link
                  style={styles.link}
                  src={`mailto:${intl.formatMessage(
                    messages.footer2_contact2,
                  )}`}
                >
                  {intl.formatMessage(messages.footer2_contact2)}
                </Link>
              </View>
              <View style={[styles.footerInfoSection]}>
                <Image style={styles.infoIcons} src={computerImage} />
                <Link
                  style={styles.link}
                  src={`https://${intl.formatMessage(
                    messages.footer2_website,
                  )}`}
                >
                  {intl.formatMessage(messages.footer2_website)}
                </Link>
              </View>
            </View>
          </View>
        </View>
      </Page>

      {/* <Page size="A4" style={styles.page}>
        <View style={styles.headerSection2} fixed>
          <Text style={[styles.headerText2]}> </Text>
        </View>
      </Page> */}
    </Document>
  );
};
